import { $FixMe } from '@eventbrite/ts-utils';
import loadable from '@loadable/component';
import first from 'lodash/first';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { handleGetPage as handleGetPageAction } from '../../../../redux/actions/pagination';
import { constructPaginatedUrl } from '../../../../redux/selectors/url';
import { EventSearch } from '../../../../types/index';
import { getSearchContent } from '../../../../utils/general';
import { hasEventResults } from '../../utils/events';
import { SearchFooter } from './components';

const SearchFooterLegacy = loadable(() => import('./components'), {
    resolveComponent: (components: any) => components.SearchFooterLegacy,
});

const SearchFooterWrapper = (props: any) => {
    const { isBotRequest } = props;
    let Footer = <SearchFooter {...props} />;

    if (isBotRequest) {
        Footer = <SearchFooterLegacy {...props} />;
    }

    return Footer;
};

const _getMaxPage = ({ event }: any) => {
    const firstKey = parseInt(first(Object.keys(event)) || '0');

    let pageCount;

    if (event[firstKey]) {
        pageCount = event[firstKey].pageCount;
    }

    return pageCount;
};

const _getTotalResults = ({ event }: any) => {
    const firstKey = parseInt(first(Object.keys(event)) || '0');

    let totalNumResults = 0;

    if (event[firstKey]) {
        totalNumResults = event[firstKey].objectCount || 0;
    }

    return totalNumResults;
};

const _isNextDisabled = (pagination: any) => {
    const pageCount = _getMaxPage(pagination);
    const { currentPage } = pagination;

    return currentPage === pageCount - 1;
};

const _mapStateToProps = (
    state: {
        app: { isBotRequest: boolean };
        pagination: {
            currentPage: number;
            paginationData?: Record<string, any> | undefined;
        };
        search: { eventSearch: EventSearch };
        location: { slug: string };
        content: { entities: $FixMe };
        currencyFormat?: string;
    },
    ownProps: {
        history: {
            location: { search?: string; pathname?: string; hash?: string };
        };
    },
) => ({
    isBotRequest: state.app.isBotRequest,
    currentPage: state.pagination.currentPage,
    pageCount: _getMaxPage(state.pagination),
    isNextDisabled: _isNextDisabled(state.pagination),
    prevPageUrl: constructPaginatedUrl(
        state.pagination.currentPage - 1,
        state.search.eventSearch,
        state.location.slug,
        ownProps.history.location,
    ),
    nextPageUrl: constructPaginatedUrl(
        state.pagination.currentPage + 1,
        state.search.eventSearch,
        state.location.slug,
        ownProps.history.location,
    ),
    firstPageUrl: constructPaginatedUrl(
        0,
        state.search.eventSearch,
        state.location.slug,
        ownProps.history.location,
    ),
    lastPageUrl: constructPaginatedUrl(
        _getMaxPage(state.pagination) - 1,
        state.search.eventSearch,
        state.location.slug,
        ownProps.history.location,
    ),
    hasEventResults: hasEventResults(
        getSearchContent(
            state.content.entities,
            state.pagination,
            state.currencyFormat,
        ),
    ),
    totalNumResults: _getTotalResults(state.pagination),
});

const _mapDispatchToProps = {
    handleGetPage: handleGetPageAction,
};

export const SearchFooterContainer = withRouter(
    connect(_mapStateToProps, _mapDispatchToProps)(SearchFooterWrapper),
);
